import { render, staticRenderFns } from "./UpdatePasswordStep1.vue?vue&type=template&id=13670cf0&scoped=true&"
import script from "./UpdatePasswordStep1.vue?vue&type=script&lang=js&"
export * from "./UpdatePasswordStep1.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePasswordStep1.vue?vue&type=style&index=0&id=13670cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13670cf0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCol,VDivider,VForm,VRow,VTextField})
